"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
require("./styles.css");
var Icon_1 = __importDefault(require("@component/Icon"));
var WbrString_1 = __importDefault(require("@component/WbrString"));
var react_outside_click_handler_1 = __importDefault(require("react-outside-click-handler"));
var MobileHeader = /** @class */ (function (_super) {
    __extends(MobileHeader, _super);
    function MobileHeader(props) {
        var _this = _super.call(this, props) || this;
        _this.languageInfo = function () {
            return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "language_list" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "language_box" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "language_close_icon", onClick: _this.toggleLanguageMenu }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { iconType: "xMark", color: "#878D90", size: "md" }) })), (0, jsx_runtime_1.jsx)("ul", { children: _this.props.languageList &&
                                _this.props.languageList.map(function (item, idx) {
                                    return (0, jsx_runtime_1.jsx)("li", { children: item }, idx);
                                }) })] })) })));
        };
        _this.toggleNav = function () {
            console.log("toggle-open");
            _this.setState(function (prevState) { return ({
                showMobileNav: !prevState.showMobileNav,
            }); });
        };
        _this.toggleSearch = function () {
            _this.setState(function (prevState) { return ({
                showSearchBox: !prevState.showSearchBox,
            }); });
        };
        _this.toggleRegister = function () {
            _this.setState(function (prevState) { return ({
                showRegisterInfo: !prevState.showRegisterInfo,
            }); });
        };
        _this.toggleLanguageMenu = function () {
            _this.setState(function (prevState) { return ({
                showLanguageMenu: !prevState.showLanguageMenu,
            }); });
        };
        _this.state = {
            showMobileNav: false,
            showSearchBox: false,
            showRegisterInfo: false,
            showLanguageMenu: false,
        };
        return _this;
    }
    MobileHeader.prototype.render = function () {
        var _this = this;
        var _a = this.props, languageSelected = _a.languageSelected, searchText = _a.searchText, menuText = _a.menuText, myRotaryLink = _a.myRotaryLink, logo = _a.logo, otherLinks = _a.otherLinks, searchPlaceholderText = _a.searchPlaceholderText, mainNav = _a.mainNav, navRightInfo = _a.navRightInfo, megaNavPlaceholder = _a.megaNavPlaceholder, handleClick = _a.handleClick, handleChange = _a.handleChange, hideSearch = _a.hideSearch, kioskHeader = _a.kioskHeader;
        return ((0, jsx_runtime_1.jsxs)("header", __assign({ className: "header" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "mid_bar" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "header_container container" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "md:hidden hamburger_button" }, { children: (0, jsx_runtime_1.jsxs)("button", __assign({ className: "outline-none mobile-menu-button ".concat(!this.state.showMobileNav ? "main_nav_close" : "main_nav_open"), onClick: this.toggleNav }, { children: [(0, jsx_runtime_1.jsx)("span", { className: "nav_toggle_icon" }), " ", (0, jsx_runtime_1.jsx)(WbrString_1.default, __assign({ tag: "span" }, { children: menuText }))] })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "header_logo" }, { children: logo })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "header_links" }, { children: (0, jsx_runtime_1.jsx)("ul", { children: !hideSearch ? ((0, jsx_runtime_1.jsx)("li", __assign({ className: "search" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "header_search_icon ".concat(!this.state.showSearchBox
                                                ? "search_icon_close"
                                                : "search_icon_open"), onClick: this.toggleSearch }, { children: [(0, jsx_runtime_1.jsx)("span", { className: "nav_search_icon" }), (0, jsx_runtime_1.jsx)(WbrString_1.default, __assign({ tag: "span" }, { children: searchText }))] })) }))) : null }) })), this.state.showSearchBox ? ((0, jsx_runtime_1.jsx)(react_outside_click_handler_1.default, __assign({ onOutsideClick: function (e) {
                                    var targetElement = e.target;
                                    if (!(targetElement &&
                                        targetElement.closest &&
                                        targetElement.closest(".header_search_icon"))) {
                                        _this.setState({ showSearchBox: false });
                                    }
                                } }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "header_search" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "header_search_content" }, { children: [(0, jsx_runtime_1.jsx)("input", { id: "siteSearch", type: "search", name: "search", placeholder: searchPlaceholderText, onKeyDown: handleChange, autoFocus: true }), (0, jsx_runtime_1.jsx)("span", __assign({ className: "header_search_btn", onClick: handleClick }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { iconType: "search", color: "#019FCB", size: "md" }) }))] })) })) }))) : null] })) })), this.state.showMobileNav ? ((0, jsx_runtime_1.jsx)(react_outside_click_handler_1.default, __assign({ onOutsideClick: function (e) {
                        var targetElement = e.target;
                        if (!(targetElement &&
                            targetElement.closest &&
                            targetElement.closest(".mobile-menu-button"))) {
                            _this.setState({ showMobileNav: false });
                        }
                    } }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "mobile_nav_expand" }, { children: [megaNavPlaceholder, (0, jsx_runtime_1.jsx)("div", __assign({ className: "top_bar" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "header_container container" }, { children: (0, jsx_runtime_1.jsxs)("ul", { children: [otherLinks, (0, jsx_runtime_1.jsx)("li", __assign({ className: "home" }, { children: myRotaryLink })), kioskHeader ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})) : ((0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)(react_outside_click_handler_1.default, __assign({ onOutsideClick: function () {
                                                        _this.setState({ showLanguageMenu: false });
                                                    } }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "language_dropdown" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "lang_selected ".concat(this.state.showLanguageMenu ? 'lang_arrow_up' : ''), onClick: this.toggleLanguageMenu }, { children: [(0, jsx_runtime_1.jsxs)("span", { children: [" ", languageSelected, " "] }), (0, jsx_runtime_1.jsx)(Icon_1.default, { iconType: "angleDown", color: '#39424A', size: 'md' })] })), this.state.showLanguageMenu ? this.languageInfo() : null] })) })) }))] }) })) }))] })) }))) : null] })));
    };
    return MobileHeader;
}(React.Component));
exports.default = MobileHeader;
//# sourceMappingURL=mobile.js.map